import React from 'react';
import clsx from 'clsx';
import { CoverImages } from '@components/Playlists/basics/CoverImages';
import { usePlaylistCardInfo } from '@components/Playlists/basics/usePlaylistCardInfo';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { getFragment, PlaylistCardDetailsFragmentDoc } from '@graphql/reactQuery';
import type { FragmentType } from '@graphql/reactQuery';

export function SearchPlaylistRow({
  data,
}: {
  data: FragmentType<PlaylistCardDetailsFragmentDoc>;
}) {
  const playlist = getFragment(PlaylistCardDetailsFragmentDoc, data);

  const { playlistName, username, playlistPagePath } = usePlaylistCardInfo({
    data: playlist,
  });

  return (
    <AccessibleLink
      className="flex h-12 w-full items-center gap-3 rounded-md pr-3 hover:bg-neutral100 md:hidden"
      pathnameUri={playlistPagePath}
    >
      <div
        className={clsx(
          'relative h-12 max-h-[3rem] w-12 max-w-[3rem] overflow-hidden',
          'flex-shrink-0 transform-gpu rounded-md',
        )}
      >
        <CoverImages playlist={playlist} maxSize={48} priority={false} />
      </div>
      <div className="flex flex-col gap-1 overflow-hidden">
        <span className="overflow-hidden text-ellipsis whitespace-nowrap font-title text-title-xs font-medium text-black">
          {playlistName}
        </span>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap font-base text-base-s font-normal text-base500">
          Playlist • {username}
        </span>
      </div>
    </AccessibleLink>
  );
}
